var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgOffDutyHand = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 53,
  height: 67,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F2F2F3",
  d: "M24.5 31.5v-26a4.5 4.5 0 1 1 9 0v24"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#262B2F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M24.5 31.5v-26a4.5 4.5 0 1 1 9 0v24"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2F2F3",
  d: "M28 27h13v9H28z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2F2F3",
  d: "M33.5 29.5v-18a4.5 4.5 0 1 1 9 0v24"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#262B2F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M33.5 29.5v-18a4.5 4.5 0 1 1 9 0v24"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2F2F3",
  d: "M42.5 34V20.5a4.5 4.5 0 1 1 9 0v30a15 15 0 0 1-15 15H26.495a15.02 15.02 0 0 1-12.669-6.963C8.66 50.401 2.249 37 2.249 37a3.6 3.6 0 0 1 5.283-4.8l7.968 9.3v-30a4.5 4.5 0 1 1 9 0v18"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#262B2F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M42.5 34V20.5a4.5 4.5 0 1 1 9 0v30a15 15 0 0 1-15 15H26.495a15.02 15.02 0 0 1-12.669-6.963C8.66 50.401 2.249 37 2.249 37a3.6 3.6 0 0 1 5.283-4.8l7.968 9.3v-30a4.5 4.5 0 1 1 9 0v18"
})));
export default SvgOffDutyHand;